export { default as anchor, getAnchorLink } from './anchor';
export { default as sonyBar } from './sonyBar';

export default from './header';
